import { isPlatformBrowser } from '@angular/common';
import { Component, effect, HostListener, inject, OnDestroy, PLATFORM_ID } from '@angular/core';
import { CartService } from '../cart/cart.service';
import { BagComponent } from './bag.component';

@Component({
  selector: 'app-bag-drawer',
  standalone: true,
  imports: [BagComponent],
  templateUrl: './bag-drawer.component.html',
  styleUrl: './bag-drawer.component.scss',
})
export class BagDrawerComponent implements OnDestroy {
  private readonly platformId = inject(PLATFORM_ID);
  readonly cartService = inject(CartService);

  constructor() {
    effect(() => {
      const open = this.cartService.isDrawerOpen();
      if (!isPlatformBrowser(this.platformId)) {
        return;
      }
      document.body.classList.toggle('bag-drawer-open', open);
    });
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      document.body.classList.remove('bag-drawer-open');
    }
  }

  close(): void {
    this.cartService.closeDrawer();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.cartService.isDrawerOpen()) {
      this.close();
    }
  }
}
